import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { companyInfo } from '../data/products';

export default function WhatsAppFloat() {
  const openWhatsApp = () => {
    const msg = "Hi, I'm interested in your products. Please share more details.";
    window.open(
      `https://wa.me/${companyInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(msg)}`,
      '_blank'
    );
  };

  return (
    <Tooltip title="Chat with us!" placement="left">
      <Fab
        color="success"
        onClick={openWhatsApp}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          backgroundColor: '#25d366',
          '&:hover': {
            backgroundColor: '#1ea952',
            transform: 'scale(1.1)',
          },
          transition: 'all 0.3s ease',
          zIndex: 1000,
        }}
      >
        <WhatsApp />
      </Fab>
    </Tooltip>
  );
}
